export default function ShipBattleIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#1f86c2" />
      <path d="M8 50c5-3 9-3 14 0s9 3 14 0 9-3 14 0 6 2 8 1" stroke="#bfe9ff" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M12 40h40l-6 9H18z" fill="#7a4a26" stroke="#3e2412" strokeWidth="2" strokeLinejoin="round" />
      <rect x="31" y="10" width="3" height="30" fill="#5a3a1e" />
      <path d="M34 12c10 4 12 14 0 22z" fill="#ff8a1f" stroke="#8a4410" strokeWidth="1.5" />
      <path d="M31 14c-9 4-11 12 0 20z" fill="#ffc285" stroke="#8a4410" strokeWidth="1.5" />
      <path d="M34 10l8 2-8 3z" fill="#ff3b5c" />
      <circle cx="54" cy="34" r="3.5" fill="#222" />
      <circle cx="47" cy="35" r="2.5" fill="#eee" opacity="0.8" />
      <circle cx="43" cy="36" r="2" fill="#eee" opacity="0.6" />
      <rect x="40" y="41" width="5" height="3" fill="#222" />
      <rect x="20" y="41" width="5" height="3" fill="#222" />
    </svg>
  );
}
